var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-simple_1_",
    "data-name": "download-simple (1)",
    transform: "translate(0 0.342)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7029",
    "data-name": "Rectangle 7029",
    width: 31,
    height: 31,
    transform: "translate(0 -0.342)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64907",
    "data-name": "Path 64907",
    d: "M86,110l5.03,5.03L96.06,110",
    transform: "translate(-75.701 -96.827)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_183",
    "data-name": "Line 183",
    y2: 13,
    transform: "translate(15 4.658)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64908",
    "data-name": "Path 64908",
    d: "M61.078,152v6.706a.958.958,0,0,1-.958.958H40.958a.958.958,0,0,1-.958-.958V152",
    transform: "translate(-35.21 -133.797)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.768eab905aeaad58e4572ee11e5f38d5.svg";
export { ForwardRef as ReactComponent };